import { useState } from 'react';
import { labels } from '../lib/labels';
import { navigate } from '../lib/navigate';
import { saveReturnHash } from '../lib/return-hash';

type SignInError = 'no-role' | 'expired' | 'failed';

/** The backend sends the browser back to `/#signin-error=<code>` when a Keycloak sign-in does not finish. */
function readSignInError(): SignInError | null {
  const match = /^#signin-error=(no-role|expired|failed)$/.exec(window.location.hash);
  return match ? (match[1] as SignInError) : null;
}

const ERROR_TEXT: Record<SignInError, string> = {
  'no-role': labels.login.noRole,
  expired: labels.login.expired,
  failed: labels.login.failed,
};

/**
 * The console's first screen (ADR 0040). One primary control: the page has no other job, and the
 * password is typed on the Keycloak page, never here. The wordmark and the environment pill sit in
 * the same header the rest of the console uses, so the operator knows which deployment they are
 * about to enter; the card has the same panel shape every other screen uses.
 */
export function Login() {
  const [error] = useState(readSignInError);

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header__inner">
          <div className="app-brand">
            <h1 className="app-brand__name">{labels.appName}</h1>
          </div>
        </div>
      </header>
      <main className="app-main login">
        <section className="panel login__panel" aria-labelledby="login-title">
          <h2 id="login-title" className="login__title">
            {labels.login.title}
          </h2>
          <p className="login__lede">{labels.login.lede}</p>
          {error && (
            <div className="login__error" role="alert">
              {ERROR_TEXT[error]}
            </div>
          )}
          <button
            type="button"
            className="btn btn--primary login__submit"
            autoFocus
            onClick={() => {
              saveReturnHash(window.location.hash);
              navigate('/api/auth/login');
            }}
          >
            {labels.login.submit}
          </button>
        </section>
      </main>
      <footer className="app-colophon">
        <span>{labels.appName}</span>
        <span>
          {labels.colophon.api} <span className="app-colophon__env">{window.location.host}</span>
        </span>
      </footer>
    </div>
  );
}
